/**
 * @desc 报关信息分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  defs.basics.IPage<defs.basics.ProductDeclareInfoResponseDto>
>;
export function request(
  params: API.basics.productMaster.getDeclareInfoForPage.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productMaster/getDeclareInfoForPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
